import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";

const VehiclesFromReturnsBackToInspection = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [status, setStatus] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "PROCEED TO SECURITY DEPARTMENT" &&
              item?.DEPARTMENT === VehicleDepartment
          );
          setVehiclesList(filterData);
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "PROCEED TO SECURITY DEPARTMENT"
          );
          setVehiclesList(filterData);
        }

        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  // Saving
  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: statusValue,
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "PROCEED TO SECURITY DEPARTMENT",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  const handleRowClick = (value, index) => {
    setDriverName(value["DRIVERNAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-4">
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles From Returns Back To Inspection
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                    ? "NO"
                    : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[280px] h-[40%] lg:w-[700px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            VEHICLE FROM RETURNS
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-64 w-64 lg:ml-4"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-4">Status :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                status
                  ? { value: status, label: status }
                  : { value: "", label: "Select Status" }
              }
              onChange={(e) => {
                setStatus(e.label);
                setStatusValue(e.value);
              }}
              options={[
                { value: "", label: "Select Status" },
                { label: "PROCEED TO WORKSHOP", value: "SENT TO WORKSHOP" },
                {
                  label: "PROCEED TO LOAD",
                  value: "SENT TO LOAD",
                },
                {
                  label: "PROCEED TO WEIGHBRIDGE",
                  value: "SENT TO WEIGHBRIDGE",
                },
              ]}
            ></Select>
          </div>

          <div className="flex justify-center mt-12">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (!statusValue) {
                  alert("Kindly Supply Status");
                  return;
                } else {
                  await SaveVehicleState();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              RETURN
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default VehiclesFromReturnsBackToInspection;
